(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var moment = require('../../../../lib/moment-utc')
  , extend = require('lodash.assign')
  , BaseView = require('cf-base-view')
  , nl2br = require('../../../../lib/nl2br')
  , makeFormView = require('../views/entry-item-form')

module.exports = BaseView.extend(
  { events: extend({}, BaseView.prototype.events
    , { 'click .js-remove': 'handleRemove'
      , 'click .js-edit': 'renderItemForm'
      })

  , className: 'js-entry-item'

  , attributes: function () {
      return { 'data-cid': this.model.cid }
    }

  , initialize: function () {
      this.render()
    }

  , handleRemove: function (e) {
      e.preventDefault()
      this.model.collection.remove(this.model.cid)
      this.remove()
    }

  , handleUpdate: function () {
      this.$('.js-updated').show()
    }

  , renderItemForm: function (e) {
      e.preventDefault()

      var FormView = makeFormView(this.model.get('type'))
        , view = new FormView(
          { model: this.model
          , collection: this.model.collection
          , serviceLocator: this.options.serviceLocator
          })

      view.on('save', this.render, this)
      view.on('save', this.handleUpdate, this)

      this.attachView(view)
      view.render()
    }

  , render: function () {
      var data = this.model.get('content')
      if (data && data.date) {
        data.dateFormatted = moment(data.date).format('DD MMMM YYYY')
      }
      this.$el.html(this.template(
        { data: data
        , nl2br: nl2br
        }))
      return this
    }
  })

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/itinerary/lib/entry-item-base-view.js","/components/admin/itinerary/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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